import { useEffect, useRef } from "react";

interface IFooterPageProps extends React.HTMLProps<HTMLElement> {
  expand?: boolean;
}

// function IconExpand(){
//   return <></>
// }

export default function FooterPage({children, expand}:IFooterPageProps){
  const ref = useRef<any>(null);

  useEffect(()=>{
    let current = ref.current;
    if(current){
      let parent = current.parentNode;
      if(parent){
        let pdc = parent.getElementsByClassName("pagedefault-content");
        if(pdc.length>0){
          pdc = pdc[0];
          if(pdc){
            if(pdc.classList.contains("pagedefault-content-menu")){
              let pdmc = pdc.getElementsByClassName("pagedefault-menu-content");
              if(pdmc.length>0){
                pdmc = pdmc[0];
                if(pdmc){
                  if(!pdmc.classList.contains("space-footer")){
                    pdmc.classList.add("space-footer")
                  }
                }
              }
            } else {
              if(!pdc.classList.contains("space-footer")){
                pdc.classList.add("space-footer")
              }
            }
          }
        }
      }
    }
    
  },[]);

  return (<>
    {/* <div style={{marginTop:47}}></div> */}
    <div className="pagedefault-footer" ref={ref}>
      {children}
    </div>
  </>
  )
}